import { useEffect, useState } from "react";
import { User } from "lucide-react";
import { C, Label, Pop, Svg, useTick } from "./shared";

export const CctvAnim = ({ say }) => {
  const [open, setOpen] = useState(false);
  useTick(() => setOpen((o) => !o), 2800);
  useEffect(() => {
    say(open ? "A staff member tapped their phone on the reader — door unlocked, and it's logged." : "The camera spotted someone and flagged it — you'd get an alert on your phone.");
  }, [open, say]);

  return (
    <Svg>
      <line x1="20" y1="330" x2="580" y2="330" stroke="#334155" />
      <Pop delay={0.1}>
        <rect x="40" y="40" width="10" height="40" fill="#334155" />
        <circle cx="68" cy="82" r="18" fill="#1F2937" stroke="#475569" />
        <circle cx="72" cy="86" r="7" fill="#0B1220" stroke={C.blue} />
      </Pop>
      <g className="sweep" style={{ transformOrigin: "72px 86px" }}>
        <path d="M72,86 L260,330 L400,330 Z" fill="rgba(0,240,255,0.07)" stroke="rgba(0,240,255,0.25)" />
      </g>
      <Label x={100} y={58} anchor="start" color={C.text}>G5 TURRET · 4K</Label>
      <g className="walk">
        <foreignObject x="0" y="270" width="40" height="60">
          <div style={{ color: "#E2E8F0" }}><User size={40} strokeWidth={1.4} /></div>
        </foreignObject>
        <rect x="-6" y="264" width="52" height="68" fill="none" stroke={C.green} strokeDasharray="3 3" />
        <Label x={20} y={258} color={C.green} size={7}>PERSON 98%</Label>
      </g>
      <rect x="470" y="150" width="90" height="180" fill="#0D131E" stroke="#334155" />
      <rect x="470" y="150" width="90" height="180" fill={open ? "rgba(16,185,129,0.08)" : "transparent"} className="transition-colors" />
      <rect x="440" y="215" width="16" height="42" rx="3" fill="#111827" stroke="#475569" />
      <circle cx="448" cy="245" r="4" fill={open ? C.green : C.blue} filter="url(#aglow)" />
      {open && [0, 1].map((k) => <circle key={k} cx="448" cy="245" r="12" fill="none" stroke={C.green} className="wave-sm" style={{ animationDelay: `${k * 0.5}s` }} />)}
      <Label x={515} y={140} color={C.text}>G2 PRO READER</Label>
      <Label x={515} y={350} color={open ? C.green : C.dim} size={10} weight="700">{open ? "UNLOCKED · NFC" : "LOCKED"}</Label>
      <Label x={20} y={384} anchor="start">CAMERAS + DOORS · SAME UNIFI CONSOLE</Label>
    </Svg>
  );
};
